import type { Algebra } from '@traqula/algebra-transformations-1-2';
import type { FragmentDefinitionNode } from 'graphql/language';
import type { IConvertContext } from '../IConvertContext';
import type { IConvertSettings } from '../IConvertSettings';
import type { Util } from '../Util';
import { NodeHandlerDefinitionAdapter } from './NodeHandlerDefinitionAdapter';

/**
 * Errors if fragment definitions are found,
 * as these should have been processed away earlier.
 */
export class NodeHandlerDefinitionFragment extends NodeHandlerDefinitionAdapter<FragmentDefinitionNode> {
  public constructor(util: Util, settings: IConvertSettings) {
    super('FragmentDefinition', util, settings);
  }

  public handle(_operationDefinition: FragmentDefinitionNode, _convertContext: IConvertContext): Algebra.Operation {
    throw new Error('Illegal state: fragment definitions must be indexed and removed before processing');
  }
}
